import { Auth0Provider } from "@auth0/auth0-react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import AuthTokenBridge from "./authTokenBridge";

const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;

const Auth0ProviderWithRouter = ({ children }) => {
  const navigate = useNavigate();

  const onRedirectCallback = (appState) => {
    console.log("App State " + JSON.stringify(appState));
    navigate(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      sessionCheckExpiryDays={1}
      cacheLocation="memory"
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      <AuthTokenBridge />
      {children}
    </Auth0Provider>
  );
};

Auth0ProviderWithRouter.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Auth0ProviderWithRouter;
